import { Package } from "@/types/packages/data-only/DataOnlyCountryPackages";
import { useState } from "react";

export type PackageType = "data-only" | "data-voice";

export function usePackageType({
  dataOnlyPackages,
  dataVoicePackages,
}: {
  dataOnlyPackages?: Package[];
  dataVoicePackages?: Package[];
}) {
  const [packageType, setPackageType] = useState<PackageType>(
    dataOnlyPackages ? "data-only" : "data-voice",
  );

  const showPackageTypeToggle = dataVoicePackages && dataOnlyPackages;
  const isDataOnlyPackagesSelected = packageType === "data-only";
  const isDataVoicePackagesSelected = packageType === "data-voice";
  const activePackages =
    packageType === "data-only"
      ? (dataOnlyPackages ?? [])
      : (dataVoicePackages ?? []);

  return {
    packageType,
    setPackageType,
    showPackageTypeToggle,
    isDataOnlyPackagesSelected,
    isDataVoicePackagesSelected,
    activePackages,
  };
}
